module.exports = __webpack_public_path__ + "static/media/strike6.baf163ae.jpg";